<script setup>
import { computed, inject } from 'vue';
import { textColor, fontStack } from '../canvasStyles';
import InlineTextEditor from '../InlineTextEditor.vue';

const props = defineProps({
  element: { type: Object, required: true },
  bgValue: { type: String, default: null },
});
defineOptions({ inheritAttrs: false });
// Título e texto: mostra o HTML; duplo clique abre o editor no lugar.

const ed = inject('emailEditor');
const editing = inject('canvasEditing');
const theme = computed(() => ed.template.value?.theme || {});
const heading = computed(() => props.element.type === 'heading');
const st = computed(() => props.element.style || {});
const isEditing = computed(() => editing.value === props.element.id);
const textStyle = computed(() => ({
  fontFamily: fontStack(
    st.value.font_family,
    ed.doc.value,
    theme.value,
    heading.value
  ),
  fontSize: `${st.value.font_size}px`,
  lineHeight: st.value.line_height,
  fontWeight: heading.value ? st.value.font_weight : undefined,
  color: textColor(st.value.color, props.bgValue, theme.value),
  textAlign: st.value.align,
}));
const onUpdate = html =>
  ed.update(props.element.id, { html }, { group: `text:${props.element.id}` });
const stopEditing = () => {
  editing.value = null;
};
const startEditing = () => {
  editing.value = props.element.id;
};
</script>

<template>
  <InlineTextEditor
    v-if="isEditing"
    :html="element.html"
    :inline="heading"
    :style-object="textStyle"
    @update="onUpdate"
    @done="stopEditing"
  />
  <!-- eslint-disable-next-line vue/no-v-html -- HTML do schema do editor/servidor (sanitizado) -->
  <div
    v-else
    class="cursor-text [&_a]:underline [&_ol]:list-decimal [&_ol]:pl-6 [&_p:last-child]:mb-0 [&_p]:mb-3 [&_ul]:list-disc [&_ul]:pl-6"
    :style="textStyle"
    @dblclick.stop="startEditing"
    v-html="element.html"
  />
</template>
